import { render } from "./DialogDelete.vue?vue&type=template&id=c2802404&ts=true"
import script from "./DialogDelete.vue?vue&type=script&lang=ts"
export * from "./DialogDelete.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__